var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/men_unselected.dacdf53f.png","uri@2x": __webpack_public_path__ + "static/media/men_unselected.5993b35d.png","uri@3x": __webpack_public_path__ + "static/media/men_unselected.ed7b6c9c.png",
    width: 22,
    height: 28
});